<template>
  <auth-page-layout>
    <div class="spinner-wrap" v-if="initialLoading">
      <spinner />
    </div>

    <template v-else>
      <v-card
        class="mx-auto m-auto pa-4 mt-4 mb-8"
        max-width="480"
        v-if="isWrongDomain"
      >
        <h3 class="text-center mb-4 appMain--text">Wrong Domain</h3>
        <v-alert transition="fade-transition" class="pa-2" type="error">
          {{ errorMessage }}
        </v-alert>

        <v-btn color="appMain" href="https://app.conveyour.com/ui/login">
          Go Back
        </v-btn>
      </v-card>

      <template v-else>
        <v-card
          class="mx-auto m-auto pa-4 mt-4 mb-8"
          max-width="480"
          v-if="!isBaseDomain"
        >
          <h3 class="text-center mb-4 appMain--text">Portal Login</h3>
          <p>Are you a learner looking to locate your learner portal?</p>
          <v-btn color="appMain" :to="{ name: 'portal-home' }" target="_blank">
            Go to learner portal
          </v-btn>
        </v-card>

        <v-card class="mx-auto m-auto pa-4 mt-4" max-width="480">
          <h3 class="text-center mb-3 appMain--text">
            {{ isBaseDomain ? 'Login' : 'Admin Login' }}
          </h3>
          <login-form />
        </v-card>
      </template>
    </template>
  </auth-page-layout>
</template>

<script>
import AuthPageLayout from '@/views/auth/components/AuthPageLayout.vue';
import LoginForm from '@/views/auth/components/LoginForm.vue';
import { mapState } from 'vuex';

export default {
  name: 'LoginPage',
  components: {
    AuthPageLayout,
    LoginForm,
  },
  computed: {
    ...mapState('auth', ['loading', 'loginInfo']),
    initialLoading() {
      return this.loading && !this.loginInfo;
    },
    isWrongDomain() {
      const { action, url } = this.loginInfo || {};
      return (
        action === 'validate_subdomain' &&
        (url || '').includes('does+not+exist')
      );
    },
    errorMessage() {
      const str = (this.loginInfo?.url || '').split('message=').pop() || '';
      return str.replaceAll('+', ' ');
    },
    isBaseDomain() {
      return window.location.hostname.startsWith('app.');
    },
  },
};
</script>
